import { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { DrillHost, DRILL_LABEL, type DrillKind, DRILL_KINDS } from '@usacow/drills';
import { Button } from '@usacow/ds';
import { api } from '../lib/api';

/** Hosts a single drill of the kind in the URL, records the result, then offers next. */
export function DrillScreen() {
  const { kind } = useParams<{ kind: string }>();
  const navigate = useNavigate();
  const [done, setDone] = useState(false);
  // Remount the host on retry by bumping a key.
  const [attempt, setAttempt] = useState(0);

  if (!kind || !(DRILL_KINDS as readonly string[]).includes(kind)) {
    return <div className="route-loading">Unknown drill.</div>;
  }
  const drillKind = kind as DrillKind;

  return (
    <div className="scr scr--narrow">
      <div className="scr-head">
        <div>
          <div className="t-eyebrow">drill</div>
          <h1 className="scr-h">{DRILL_LABEL[drillKind]}</h1>
        </div>
        <Button variant="ghost" size="sm" onClick={() => navigate('/app')}>
          Exit
        </Button>
      </div>

      {!done ? (
        <DrillHost
          key={attempt}
          kind={drillKind}
          continueLabel="Done"
          onComplete={({ response }) => {
            void api.submitDrill(drillKind, response).catch(() => {});
            setDone(true);
          }}
        />
      ) : (
        <div className="dr-done">
          <div className="t-eyebrow">drill complete</div>
          <p className="dr-done__p">Logged. Your mastery for this topic just updated.</p>
          <div className="dr-done__cta">
            <Button
              variant="secondary"
              onClick={() => {
                setDone(false);
                setAttempt((a) => a + 1);
              }}
            >
              Another like this
            </Button>
            <Button variant="primary" onClick={() => navigate('/app')}>
              Back to home
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}
